import { io, type Socket } from 'socket.io-client';

export interface SocketOptions {
  url: string;
  token?: string | null;
  reconnection?: boolean;
  reconnectionAttempts?: number;
  reconnectionDelay?: number;
}

export function createSocketClient(options: SocketOptions): Socket {
  const {
    url,
    token,
    reconnection = true,
    reconnectionAttempts = Infinity,
    reconnectionDelay = 2000
  } = options;

  return io(url, {
    query: {
      token: token || ''
    },
    autoConnect: true,
    reconnection,
    reconnectionAttempts,
    reconnectionDelay,
    reconnectionDelayMax: 10000, // Max delay between reconnection attempts
    randomizationFactor: 0.5
  });
}
